import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router, applyRouterMiddleware, browserHistory } from 'react-router'
import useScroll from 'react-router-scroll/lib/useScroll'
import { syncHistoryWithStore } from 'react-router-redux'
import getRoutes from './routes'
import createStore from './stores'

import browserIsSupported from './browserDetection'

// eslint-disable-next-line no-negated-condition
if (! browserIsSupported) {
    document.write(
        `
            <div class="dialog dialog--error dialog--modal dialog--modal-open">
                <div class="dialog__content dialog__content--shadow">
                    <div class="dialog__header dialog-header">
                        <div class="dialog-header__title dialog-header__title--center">
                            <h3>Your browser is not supported</h3>
                        </div>
                    </div>
                    <div class="dialog__body dialog__body--padded">
                        <p>
                            The type of browser you are using or its version is not supported by the
                            Man With A Cam profile app.
                        </p>
                        <p>
                            To ensure the best experience, please install the latest version of the
                            recommended web browsers below.
                        </p>
                        <p>
                            <a href="http://www.google.com/chrome/" target="_blank" class="btn btn--transparent btn--full-width" style="display: block; float: left; width: 28%; margin-right: 8%; height: 125px;">
                                <img src="/img/browser-icons/chrome-128.png" width="64" />
                                Google Chrome
                            </a>
                            <a href="https://support.apple.com/en_GB/downloads/safari" target="_blank" class="btn btn--transparent btn--full-width" style="float: left; width: 28%; height: 125px;">
                                <img src="/img/browser-icons/safari-128.png" width="64" />
                                Safari
                            </a>
                            <a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank" class="btn btn--transparent btn--full-width" style="float: right; width: 28%; height: 125px;">
                                <img src="/img/browser-icons/firefox-128.png" width="64" />
                                Firefox
                            </a>
                        </p>
                        <div style="clear: both;"></div>
                    </div>
                    <div class="dialog__footer dialog-footer">
                        <div class="dialog-footer__actions dialog-footer__actions--center">
                            <a href="mailto:info@hayden5.com" class="btn btn--primary btn--full-width">
                                Contact support
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `
    )
} else {
    if (process.env.NODE_ENV !== 'development' && Raven) {
        Raven.config('https://47cb79a69d194920a34f4c07b80631c2@sentry.io/1399418', {
            environment: process.env.NODE_ENV,
            release: process.env.APP_VERSION,
        }).install()

        // Disable the image load failure logging for now, it only ever hits the S3 timeout stuff,
        // which I can't fix.

        // window.addEventListener('error', (e) => {
        //     if (e instanceof Event && ! (e instanceof ErrorEvent)) {
        //         if (e.target.src) {
        //             Raven.captureMessage('Image failed to load.', {
        //                 extra: {
        //                     src: e.target.src,
        //                     page: location.href,
        //                 },
        //             })
        //         }
        //     }
        // }, true)
    }

    for (const param of window.location.search.slice(1).split('&')) {
        const [ key, value ] = param.split('=')

        if (key === 'ref') {
            window.ref = value
        }
    }

    const store = createStore()

    // Create an enhanced history that syncs navigation events with the store
    // https://github.com/reactjs/react-router/blob/master/docs/guides/Histories.md
    const history = syncHistoryWithStore(browserHistory, store)

    render(
        <Provider store={ store }>
            <Router
                history={ history }
                render={ applyRouterMiddleware(useScroll()) }
                routes={ getRoutes(store) }
            />
        </Provider>,
        document.getElementById('app')
    )
}



// WEBPACK FOOTER //
// ./app/index.js